/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserTicketAmountDto } from '../../models/center-user-ticket-amount-dto';

export interface CenterSalaryControllerGetTicketAmountByDate$Params {
  centerUserId: string;
  startAt: string;
  endAt: string;
}

export function centerSalaryControllerGetTicketAmountByDate(http: HttpClient, rootUrl: string, params: CenterSalaryControllerGetTicketAmountByDate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserTicketAmountDto>> {
  const rb = new RequestBuilder(rootUrl, centerSalaryControllerGetTicketAmountByDate.PATH, 'get');
  if (params) {
    rb.query('centerUserId', params.centerUserId, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterUserTicketAmountDto>;
    })
  );
}

centerSalaryControllerGetTicketAmountByDate.PATH = '/api/center-salary/ticket-amount/date';
